// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2kNn9","log":"ModalInventoryLogs_log__1OCV0","date":"ModalInventoryLogs_date__1azAW","userName":"ModalInventoryLogs_userName__3mJaw"};